import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-article-list',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.less']
})
export class ArticleListComponent {
  @Input() data: any;
}
